<template>
	<div>
		<!-- style="width: 100%; height: 240px" -->
		<ag-grid-vue v-bind:style="{ height: heightInside }" style="width: 100%; "
			class="ag-theme-balham center-box elevation-2 taskValidationGrid" :columnDefs="columnDefs"
			:rowData="rowData" :gridOptions="gridOptions" :rowSelection="rowSelection" :enableCellChangeFlash="true"
			@selection-changed="onSelectionChanged" @grid-ready="onGridReady" pagination=true
			:overlayNoRowsTemplate="overlayNoRowsTemplate" data-cy="all-tasks"></ag-grid-vue>
	</div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import { dateService } from "@/services/date.service.js";
import "ag-grid-community/styles//ag-grid.css";
import "ag-grid-community/styles//ag-theme-alpine.css";

import { STORE_CONSTANTS } from "@/common/store.constants.js";
import { mapGetters } from "vuex";

export default {
	name: "AllTaskListView",
	props: {
		heightInside: String,
		isExporting: Boolean,
		study: String
	},
	components: {
		AgGridVue
	},
	data: () => ({
		STORE_CONSTANTS,
		columnDefs: null,
		rowData: null,
		selectedRowData: null,
		loading: false,
		rowSelection: "single",
		gridApi: null,
		results: null,
		totalItems: null,
		overlayNoRowsTemplate: null,
	}),
	computed: {
		dataGrid: function () {
			return this.$store.getters["allTasks/getTasks"];
		},
		...mapGetters("allTasks", [
			"getTasks"
		]),
	},
	watch: {
		// whenever question changes, this function will run
		dataGrid: function (newValue, oldValue) {
			if (newValue !== oldValue) {
				this.gridApi.setRowData(newValue)
			}
		},
		isExporting: function (newValue, oldValue) {
			if (newValue === true) {
				const data = this.gridApi.getDataAsCsv();
				this.$emit('rowsExported', { data });
			}
		},
		study: function (newValue, oldValue) {
			if (newValue !== oldValue) {
				this.gridApi.setColumnDefs([]);
				this.loadDataGridConfiguration()
			}
		}
	},
 	 /**
	 * Component lifecycle updated handler
	 */
	created() {
		const me = this;
		me.overlayNoRowsTemplate = '<span style="padding: 10px; border: 2px solid #2b7588; background: #e0e0e0; font-size: 14px">There is no data for this query.</span>';
	},
 	 /**
	 * Component lifecycle updated handler
	 */		
	beforeMount() {
		this.type = "listView";
		this.gridOptions = {};
		this.gridOptionsCases = {};
		this.rowSelection = "single";
	},
	/**
	 * Component lifecycle updated handler
	 */
	mounted() {
		this.loadDataGridConfiguration()
		this.gridApi = this.gridOptions.api;
		this.gridColumnApi = this.gridOptions.columnApi;

		// better approach to this...
		window.addEventListener('resize', this.onResize);

		this.rowData = (this.getTasks) ? this.getTasks : [];
		this.gridApi.setRowData(this.rowData);
	},
 	 /**
	 * Component lifecycle updated handler
	 */	
	updated() {
		this.onResize()
	},
	// beforeDestroy() {

	// 	this.gridApi.destroy();
	// 	this.gridColumnApi.destroy();

	// 	window.removeEventListener('resize', this.onResize);
	// },
	/**
	 * Component lifecycle updated handler
	 */
	beforeUnmount() {
		this.gridApi.destroy();

		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		getMiles(meters) {
			let miles
			if (meters || meters === 0) {
				miles = (meters * 0.000621371192).toFixed(2) + 'miles'
			}
			return miles
		},
		getFormattedDate(date, point) {
			if (date && date.length) {
				return dateService.formatDateTimeLocal(date, point);
			}
			return 'N/A';
		},
		/**
		 * Helper to clear the sort and filters.
		 */
		clearSortAndFilter() {
			this.gridColumnApi.applyColumnState({
				defaultState: { sort: null }
			});
			this.gridApi.setFilterModel(null);
		},
		/**
		 * Handles ag grid row selection change event
		 */
		onSelectionChanged() {
			this.$emit('enableDailyCard', false)
			this.selectedRowData = this.gridApi.getSelectedRows();
			this.$store.dispatch(this.STORE_CONSTANTS.ALL_TASKS.ACTIONS.WITH_NAMESPACE.SET_SELECTED_TASK, this.selectedRowData[0]);
		},
		/**
		 * Handles ag grid row double click event
		 * @param {*} evt 
		 */
		onRowDoubleClicked(evt) {
			this.selectedRowData = evt.data;
			if (this.selectedRowData) {
				this.rightRowData = this.selectedRowData.caseList;
				this.assignStaffId = this.selectedRowData.idStaff;
			}
		},
		/**
		 * Load column definitions 
		 */
		loadDataGridConfiguration() {
			const me = this
			this.columnDefs = null;
			var myUiComponents = JSON.parse(localStorage.getItem('myUiComponents'))
			var mySingleUiComponent;
			// grab the UI components for the matching study
			for (let piece of myUiComponents) {
				if (piece.idStudyCode === me.study && piece.uiComponents) {
					mySingleUiComponent = piece.uiComponents
				}
			}
			// do not proceed if mySingleUiComponent is null
			if (!mySingleUiComponent) {
				console.log('uicomponent not loaded')
				return;
			}

			var dataGridConfig = mySingleUiComponent.find(obj => {
				return obj.componentName === 'tasksByStatus'
			})
			// set the columns, with constant and custom info
			var createdColumns = []
			for (let columnObj of dataGridConfig.columnDefs) {
				// constant info + hide and order custom attributes
				let oneColumn = {
					resizable: true,
					sortable: true,
					filter: true,
					cellStyle: { display: 'flex' },
					hide: columnObj.hide,
					sortingOrder: columnObj.order,
					field: columnObj.field,
					filterParams: { newRowsAction: 'keep' }
				}

				// Overriding if cellRender exist
				if (columnObj.cellRenderer !== '') {
					var cellRenderName = columnObj.cellRenderer
					// custom for cluster duration (milisecond to hours minutes )
					if (cellRenderName === "crTaskCluster_Duration") {
						oneColumn.cellRenderer = (params) => {
							if (params.data.clusterDuration) {
								var stringData = params.data.clusterDuration + '';
								return dateService.formatDurationMilliToHourSec(stringData);
							}
						}
					}
					// custom for cluster distance ( meters to miles)
					if (cellRenderName === "crTaskCluster_Distance") {
						oneColumn.cellRenderer = (params) => {
							return me.getMiles(params.data.clusterDistance)
						}
					}
				}
				// Overriding if valueGetter exist
				if (columnObj.valueGetter !== '') {
					var valueGetterName = columnObj.valueGetter
					if (valueGetterName === "vgTaskStaffName") {
						oneColumn.field = "nameFirst";
						oneColumn.valueGetter = (params) => {
							return `${params.data.nameFirst} ${params.data.nameLast}`;
						}
						oneColumn.cellRenderer = (params) => {
							return (
								params.data.nameFirst + " " + params.data.nameLast
							)
						}
					}

					// Displays whether or not the task has an alternate location. The field is not always
          			// present on the task object, so we need to check if it exists before returning a value.
          			if(valueGetterName === "vgTaskAltLocation") {
						oneColumn.field = "alternateLocation";
						oneColumn.valueGetter = (params) => {
							return (params.data.alternateLocation) ? params.data.alternateLocation : false;
						}
					}
				}
				// for some reason manager and supervisor aren't supplied with a field data
				if (columnObj.field === "" && columnObj.headerName === "Manager") {
					oneColumn.cellRenderer = (params) => {
						return (
							params.data.fieldMgrName
						)
					}
				}
				if (columnObj.field === "" && columnObj.headerName === "Supervisor") {
					oneColumn.cellRenderer = (params) => {
						return (
							params.data.fieldSupName
						)
					}
				}

				if (columnObj.field === "dateStart") {
					oneColumn.valueGetter = (params) => {
						var daF = dateService.formatDateBlank(params.data.dateStart);
						return (
							this.getFormattedDate(daF, params.data.point)
						)
					}
					oneColumn.cellRenderer = (params) => {
						var daF = dateService.formatDateBlank(params.data.dateStart);
						return (
							this.getFormattedDate(daF, params.data.point)
						)
					}
				}

				if (columnObj.field === "dateEnd") {
					oneColumn.valueGetter = (params) => {
						return dateService.formatDateTimeBottomTable(params.data.dateEnd, params.data.point);
					}
					oneColumn.cellRenderer = (params) => {
						return dateService.formatDateTimeBottomTable(params.data.dateEnd, params.data.point);
					}
				}

				if (columnObj.field === "taskStatus") {
					oneColumn.cellStyle = (params) => {
						if (params.value === "SUSPECT") {
							return { backgroundColor: "rgb(128,0,0,0.2)" };
						}
						if (params.value === "VALID") {
							return { backgroundColor: "rgb(0,128,0,0.2)" };
						}
						if (params.value === "UNDER_REVIEW") {
							return { backgroundColor: "rgb(0,128,128,0.2)" };
						}
						if (params.value === "UNKNOWN") {
							return { backgroundColor: "rgb(128,0,128,0.2)" };
						}
						if (params.value === "NO_DATA") {
							return { backgroundColor: "rgb(64,0,64,0.2)" };
						}
					}
				}
				// adding a column to columns list
				createdColumns.push(oneColumn)
			}
			console.log('createdColumns', createdColumns)
			this.columnDefs = null
			this.columnDefs = []
			this.columnDefs = createdColumns;
		},
		/**
		 * Handles resize event
		 * @param {*} event 
		 */
		onResize(event) {
			this.gridApi.sizeColumnsToFit();
		},
		/**
		 * Handles on grid ready event
		 * @param {*} params 
		 */
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
			console.log('this.gridColumnApi', this.gridColumnApi)
			params.api.sizeColumnsToFit();
		},
	},
};
</script>

<style scoped>
.ag-header-cell-text {
	color: #2b7588;
}
</style>
